export default __webpack_public_path__ + "static/media/IMG-20250105-WA0016.5e882c3e.jpg";